<template>
  <div ref="bienvenidaRef" class="bienvenida-section">

    <!-- Línea ondulada superior (baja de izquierda a derecha) -->
    <svg 
      class="linea-ondulada linea-arriba" 
      viewBox="0 0 1200 500" 
      preserveAspectRatio="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M0,0
           C120,30 150,170 300,200
           C430,230 500,150 620,170
           C760,195 800,320 900,400
           C1000,480 1100,490 1200,500"
        fill="none"
        stroke="#7A3D48 "
        stroke-width="3"
        stroke-linecap="round"
      />
    </svg>

    <div ref="encabezadoRef" class="encabezado-container">
      <p class="encabezado-fecha"></p><br>

      <h2 class="encabezado-nombres">
        <span class="nombre-principal">KARLA JAZMÍN  </span><br>
        <span class="apellidos-novios">Dado Castillo </span><br>

        <div class="separador-central">
          <div class="ampersand">&</div>
        </div>

        <span class="nombre-principal">JESÚS ALEXIS</span><br>
        <span class="apellidos-novios">Medina Sánchez</span>
      </h2>
    </div>

    <div class="bienvenida-container">

      <p ref="textoPrincipalRef" class="bienvenida-text">
        {{ mensaje }}
      </p>

      <p ref="versiculoRef" class="versiculo"></p>
      <img ref="fotoRef" src="@/assets/Karla y Jesús Preboda- 027___.webp" alt="Foto Novios" class="foto-destacada" />

      <p ref="nosCasamosRef" class="textmia">
        {{ mensajeFinal }}
      </p>

      <!-- FOTO PRINCIPAL -->

      <div ref="padresContainerRef" class="padres-container">

        <p ref="bendicionRef" class="bienvenida-text bendicion-text">
          Con la Bendición de Dios y en compañía de
        </p>

        <h3 class="padres-titulo" ref="padresTituloRef">
          <br /> NUESTROS PADRES
        </h3>

        <p
          v-for="(padre, i) in listaPadres"
          :key="'padre-' + i"
          class="padres-nombre"
          :ref="el => { if (el) padresRefs[i] = el }"
          v-html="padre"
        >
        </p>

      </div>

      <!-- PADRINOS 
      <div ref="padrinosContainerRef" class="padrinos-container">

        <h3
          ref="padrinosTituloRef"
          class="padres-titulo"
        >
          <br /> NUESTROS PADRINOS
        </h3>

        <div
          v-for="(padrino, i) in listaPadrinos"
          :key="'padrino-' + i"
          class="padrino-bloque"
          :ref="el => { if (el) padrinosRefs[i] = el }"
        >
          <span class="padrino-categoria">
            {{ padrino.categoria }}
          </span>

          <p class="padrinos-nombre">
            {{ padrino.nombres }}
          </p>
        </div>

      </div>-->

    </div>

    <!-- Línea ondulada inferior (sube de izquierda a derecha) -->
    <svg 
      class="linea-ondulada linea-abajo" 
      viewBox="0 0 1200 500" 
      preserveAspectRatio="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M0,500
           C120,470 150,330 300,300
           C430,270 500,350 620,330
           C760,305 800,180 900,100
           C1000,20 1100,10 1200,0"
        fill="none"
        stroke="#7A3D48 "
        stroke-width="3"
        stroke-linecap="round"
      />
    </svg>

  </div>
</template>
<script>
import { ref, onMounted, nextTick } from 'vue'
import { gsap } from 'gsap'

export default {
  name: 'BienvenidaPage',

  setup() {

    const bienvenidaRef = ref(null)
    const encabezadoRef = ref(null)
    const textoPrincipalRef = ref(null)
    const versiculoRef = ref(null)
    const nosCasamosRef = ref(null)
    const fotoRef = ref(null)

    const padresTituloRef = ref(null)
    const padresContainerRef = ref(null)
    const bendicionRef = ref(null)
    const padresRefs = ref([])

    // Refs para Padrinos
    const padrinosContainerRef = ref(null)
    const padrinosTituloRef = ref(null)
    const padrinosRefs = ref([])

    const mensaje = ref('')
    const mensajeFinal = ref('')

    const listaPadres = [
      'Ascención Castillo Ramos',
      'Eliseo Dado Rodríguez <i class="fa-solid fa-cross cruz-fa"></i>',
      '&',
      'Ma. de Jesús Sánchez Sillas',
      'Víctor Medina Luna <i class="fa-solid fa-cross cruz-fa"></i>'
    ]

    const listaPadrinos = [
      {
        categoria: 'Iglesia',
        nombres: 'Cristina y Lauro Garza'
      },
      {
        categoria: 'Anillos',
        nombres: 'Kimberly y Víctor Berrios'
      },
      {
        categoria: 'Lazo',
        nombres: 'Blanca y Manuel Anguiano'
      },
      {
        categoria: 'Arras',
        nombres: 'Maribel y Carlos García'
      },
      {
        categoria: 'Libro y Rosario',
        nombres: 'Rosa Nilda Flores'
      }
    ]

    const text = `Nuestro amor nos llevó hasta este instante, donde dos corazones eligen un solo camino para toda la vida.`


    const textFinal = '¡Nos Casamos!'

    onMounted(async () => {

      await nextTick()

      // ESTADO INICIAL
      gsap.set([
        encabezadoRef.value,
        textoPrincipalRef.value,
        versiculoRef.value,
        nosCasamosRef.value,
        fotoRef.value,
        bendicionRef.value,
        padresTituloRef.value,
        ...padresRefs.value,
        padrinosTituloRef.value,
        ...padrinosRefs.value
      ], {
        opacity: 0,
        y: 40
      })

      const observer = new IntersectionObserver((entries, obs) => {

        entries.forEach(entry => {

          if (!entry.isIntersecting) return

          const tl = gsap.timeline({
            defaults: {
              ease: 'power2.out',
              duration: 1
            }
          })

          tl.to(encabezadoRef.value, {
            opacity: 1,
            y: 0
          })

          .add(() => {
            mensaje.value = text
          })

          .to(
            textoPrincipalRef.value,
            {
              opacity: 1,
              y: 0
            },
            '>-0.5'
          )

          .to(
            versiculoRef.value,
            {
              opacity: 1,
              y: 0
            },
            '>-0.4'
          )

          .add(() => {
            mensajeFinal.value = textFinal
          })

          .to(
            nosCasamosRef.value,
            {
              opacity: 1,
              y: 0
            },
            '>-0.4'
          )

          .to(
            fotoRef.value,
            {
              opacity: 1,
              y: 0
            },
            '>-0.4'
          )

          .to(
            bendicionRef.value,
            {
              opacity: 1,
              y: 0
            },
            '>-0.4'
          )

          .to(
            padresTituloRef.value,
            {
              opacity: 1,
              y: 0
            },
            '>-0.3'
          )

          .to(
            padresRefs.value,
            {
              opacity: 1,
              y: 0,
              stagger: 0.25
            },
            '>-0.2'
          )

          // PADRINOS
          .to(
            padrinosTituloRef.value,
            {
              opacity: 1,
              y: 0
            },
            '>-0.1'
          )

          .to(
            padrinosRefs.value,
            {
              opacity: 1,
              y: 0,
              stagger: 0.25
            },
            '>-0.2'
          )

          obs.unobserve(entry.target)

        })

      }, {
        threshold: 0.2
      })

      observer.observe(bienvenidaRef.value)

    })

    return {
      bienvenidaRef,
      encabezadoRef,
      textoPrincipalRef,
      versiculoRef,
      fotoRef,
      nosCasamosRef,
      padresTituloRef,
      padresContainerRef,
      bendicionRef,
      padresRefs,
      padrinosContainerRef,
      padrinosTituloRef,
      padrinosRefs,
      mensaje,
      mensajeFinal,
      listaPadres,
      listaPadrinos
    }
  }
}
</script>

<style scoped>
/* SOLO ICONO DE CRUZ */

::v-deep .cruz-fa {
  color: #a17e4e;
  font-size: 13px;
  margin-left: 6px;
  vertical-align: middle;
}
.versiculo {
  align-self: flex-end;
  margin-right: 10px;
  margin-top: -10px;
  font-family: 'padres', serif;
  font-size: 13px;
  color: #666;
  font-style: italic;
  opacity: 0;
}

.small-cross {
  font-size: 0.8em;
  color: #a17e4e;
  margin-left: 4px;
}

.bienvenida-section {
  position: relative;
  padding: 60px 0;
 background-color: #F4F1E9; ; 
 
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  overflow: hidden;
}

/* ESTILOS DE AMBAS LÍNEAS ONDULADAS */
.linea-ondulada {
  position: absolute;
  left: 0;
  width: 100%;
  height: 120px;
  pointer-events: none;
  z-index: 1;
}

.linea-arriba {
  top: 0;
}

.linea-abajo {
  bottom: 0;
}

.encabezado-container {
  text-align: center;
  margin-top: 30px;
  margin-bottom: 20px;
  opacity: 0;
  transform: translateY(50px);
  position: relative;
  z-index: 2;
}

.encabezado-fecha {
  font-family: 'Karla', sans-serif;
  font-size: 14px;
  color: #555;
  letter-spacing: 1px;
  text-transform: uppercase;
  margin-bottom: 10px;
}

.encabezado-nombres {
  font-family: 'Playfair Display', serif;
  font-size: 32px;
  font-weight: bold;
  color: #1e1e1e;
  line-height: 1.2;
}

.nombre-principal {
  font-family: 'nombres';
  font-weight: 400;
}

.bienvenida-container {
  text-align: center;
  padding: 30px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 2;
}

.bienvenida-text {
  font-size: 18px;
  font-family: 'padres';
  color: #333;
  margin: 20px;
  transform: translateY(20px);
  opacity: 0;
  white-space: pre-line;
}

.bendicion-text {
  margin-top: 10px;
  margin-bottom: 10px;
}

.textmia {
  font-family: "say2";
  font-size: 26px;
  color: #C6A66A ;
  margin-top: 20px;
  opacity: 0;
}

.foto-destacada {
  width: 100%;
  max-width: 100%;
  height: auto;
  display: block;
  margin: 20px 0;
  opacity: 0;
  object-fit: cover;
}

.padres-container, .padrinos-container {
  margin-top: 20px;
  text-align: center;
}

.separador-central {
  text-align: center;
  margin: 10px 0;
}

.padres-titulo {
  font-family: 'Playfair Display', serif;
  font-size: 22px;
  font-weight: 500;
  color: #686D55;
  line-height: 1.5;
  margin-bottom: 20px;
  letter-spacing: 1px;
}

.apellidos-novios {
  font-size: 30px;
  font-family: "Hearth Stone", sans-serif;
  font-weight: 400;
  line-height: 1.5;
  color: #C6A66A ;
  letter-spacing: 3px;
}

.padres-nombre {
  font-family: 'Playfair Display', serif;
  font-size: 19px;
  color: #444;
  margin-bottom: 8px;
  opacity: 0;
}

.ampersand {
  font-size: 30px;
  line-height: 0.8;
  color: #C6A66A ;
  opacity: 0.95;
  margin-top: 18px;
  margin-bottom: 18px;
  font-family: 'padres', serif;
}

/* ✨ ESTILOS EXCLUSIVOS PARA PADRINOS */
.padrino-bloque {
  margin-bottom: 14px;
  opacity: 0;
}

.padrino-categoria {
  font-family: 'Playfair Display', serif;
  font-size: 16px;
  color: #C6A66A ;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  display: block;
  margin-bottom: 2px;
}

.padrinos-nombre {
  font-family: 'Playfair Display', serif;
  font-size: 16px;
  color: #444;
  margin: 0;
}

/* ✨ ESTILO DE FONT AWESOME EN COLOR CAFÉ DORADO */
::v-deep .cruz-fa {
  color: #C6A66A ;
  font-size: 13px;
  margin-left: 6px;
  vertical-align: middle;
}

@media (max-width: 600px) {
  .linea-ondulada {
    height: 80px;
  }
}
</style>